module.exports = __webpack_public_path__ + "img/home-silhouette-optimized.5336dc54.png";